import {
  ANALYZE_CHECKOUT_STEP_VIEW,
  ANALYZE_ORDER_CONFIRMATION_PAGE,
  AnalyzeCheckoutStepViewAction,
  AnalyzeOrderConfirmationPageAction,
  CHECKOUT_STEP,
} from 'b2b-apps/shop/analytics/redux';

const analyzeCheckoutStepView = (step: CHECKOUT_STEP): AnalyzeCheckoutStepViewAction => ({
  type: ANALYZE_CHECKOUT_STEP_VIEW,
  payload: {
    step,
  },
});

const analyzeOrderConfirmationPage = (isCollectedOrder?: boolean): AnalyzeOrderConfirmationPageAction => ({
  type: ANALYZE_ORDER_CONFIRMATION_PAGE,
  payload: {
    isCollectedOrder,
  },
});


export {
  analyzeCheckoutStepView,
  analyzeOrderConfirmationPage,
};
